import {Col, Container, Row} from "reactstrap";
import "bootstrap/dist/css/bootstrap.css";

import React, {Component} from "react";
import 'antd/dist/antd.css';

import {Alternate, Check, Download, Extension, Rotate, Update, UserIcon} from "../../../components/Icons/Icons";
import Oval from "../../../components/Frame/Frame";
import Feature from "./Feature/FeatureTypeFourth";
import Slider from "./Slider/Slider";
import Button from "../../../components/Button/Button";
import {Fade} from "react-awesome-reveal";
import classes from "./FeaturesLayoutsTypeSeventeenth.module.css"

const title = "Complete Solution For Biomedical Teams";
const description = "Operational since 2017, we have worked closely with big and small biomedical orgs to build a complete solution.";


class AssetFeatureCarousel extends Component {

    state = {
        features: [
            {
                title: 'Asset Transfer',
                description: 'Track asset transfer to another department or group hospital. Verify transfer.',
                icon: <Rotate fill="#ffffff"/>
            },
            {
                title: 'Checklists',
                description: 'Use checklists and ensure adherence to qualitative, quantitative and PM tasks.',
                icon: <Check fill="#ffffff"/>
            },
            {
                title: 'Daily Rounds',
                description: 'Digitize daily round logs with user verification and track observations at asset level.',
                icon: <Update fill="#ffffff"/>
            },
            {
                title: 'Barcode Tags',
                description: 'Tag physical assets using bar code or QR code stickers and use our mobile app for quick access.',
                icon: <Alternate fill="#ffffff"/>
            },
            {
                title: 'User Roles',
                description: 'Assign user roles between service engineers and other users and control who can do what.',
                icon: <UserIcon fill="#ffffff"/>
            },
            {
                title: 'Export',
                description: 'Download your asset, incident data at any point in time as an administrator in XLS/CSV format.',
                icon: <Download fill="#ffffff"/>
            },
            {
                title: 'API Access',
                description: 'Integrate with your existing systems. Use webhooks to create an asset record automatically.',
                icon: <Extension fill="#ffffff"/>
            },
        ]
    }

    renderCards () {
        const card = this.state.features;
        const listItems = card.map((item, index) => {
            return (
                <Feature
                    key={index}
                    title={item.title}
                    description={item.description}
                    dark={this.props.dark ? true : false}
                >
                    <Oval
                        variant={"large"}
                        color={"secondary"}
                    >
                        {item.icon}
                    </Oval>
                </Feature>
            )
        });
        return (
            <Slider
                array={listItems}
                dark={this.props.dark ? true : false}
            />
        );
    }

    render() {

        return (
            <div>
                <section className={`section ${classes.features} ${(this.props.dark) ?  `dark ${classes.dark}` : ''}`}>
                    <Container className={classes.container}>
                        <Row className={classes.headerRow}>
                            <Col lg="10" md="10" className={`mx-auto text-center ${classes.col}`}>
                                <div className={classes.gridWrapper}>
                                    <Fade down>
                                        <h1 className={`title ${classes.title}`}>{title}</h1>
                                    </Fade>
                                    <Fade down delay={50} triggerOnce={true}>
                                        <p className={`description ${classes.description}`}>{description}</p>
                                    </Fade>
                                </div>
                            </Col>
                        </Row>
                        <Row className={classes.featuresRow}>
                            <Col className="p-0">
                                <Fade down delay={100} triggerOnce={true}>
                                    {this.renderCards()}
                                </Fade>

                            </Col>
                        </Row>
                        <Row className={classes.buttonsRow}>
                            <Col lg="10" md="10" className="mx-auto d-flex justify-content-center">
                                <Fade down delay={150} triggerOnce={true}>
                                    <Button
                                        link={true}
                                        href={"#contact-us"}
                                        classes={`primary large simple ${classes.button}`}
                                        value={"Get Started"}
                                    />
                                </Fade>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        )
    }

}

export default AssetFeatureCarousel
